import { render, staticRenderFns } from "./T-F-Under-Grad-2023.vue?vue&type=template&id=1c3004fc&scoped=true&"
import script from "./T-F-Under-Grad-2023.vue?vue&type=script&lang=js&"
export * from "./T-F-Under-Grad-2023.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3004fc",
  null
  
)

export default component.exports